// Types
import { NavigationItemProps } from '@/types';

// Constants
import { PROJECT_NAV_LINKS } from '@shared/constants';

// Components
import { UsersIcon } from '@shared/icons/UsersIcon';
import { VoiceIcon } from '@shared/icons/VoiceIcon';
import { BracketIcon } from '@shared/icons/BracketIcon';
import { CalendarBoxIcon } from '@shared/icons/CalendarBoxIcon';
import ArchiveTickIcon from '@shared/icons/ArchiveTickIcon';
export const PROJECT_NAV_ITEMS: NavigationItemProps[] = [{
  icon: <VoiceIcon className="size-5" />,
  href: PROJECT_NAV_LINKS.INFORMATION
}, {
  icon: <BracketIcon className="size-5" />,
  href: PROJECT_NAV_LINKS.TECHNICAL_STACK
}, {
  icon: <UsersIcon className="size-5" />,
  href: PROJECT_NAV_LINKS.MEMBERS
}, {
  icon: <CalendarBoxIcon className="size-5" />,
  href: PROJECT_NAV_LINKS.ACTIVITIES
}];
export const EMPLOYEE_INSIGHT_NAV_ITEMS: NavigationItemProps[] = [{
  icon: <VoiceIcon className="size-5" />,
  href: '#employee-info'
}, {
  icon: <BracketIcon className="size-5" />,
  href: '#employee-skills'
}, {
  icon: <ArchiveTickIcon className="size-5" />,
  href: '#employee-projects'
}, {
  icon: <UsersIcon className="size-5" />,
  href: '#employee-relationships'
}, {
  icon: <CalendarBoxIcon className="size-5" />,
  href: '#employee-activities'
}];